<template>
  <thead>
    <tr class="dark:bg-ontick-steel-600 bg-ontick-steel-300 font-bold">
      <th v-for="header in headers" :key="header.key">
        <button
          class="flex items-center gap-1 py-2 px-4 text-left font-bold"
          @click="sort(header.key)"
        >
          <span v-if="header.key === sortKey">
            {{ sortIcon }}
          </span>
          <span>
            {{ header.label }}
          </span>
        </button>
      </th>
    </tr>
  </thead>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array, // {key, label, visible?}
    },
  },

  data() {
    return {
      sortDirection: "",
      sortKey: "",
    };
  },

  computed: {
    sortIcon() {
      const directions = {
        asc: "▲",
        desc: "▼",
      };
      return directions[this.sortDirection] || "";
    },
  },

  methods: {
    sort(key) {
      if (key) {
        if (this.sortKey === key) {
          this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
        } else {
          this.sortDirection = "asc";
        }
        this.sortKey = key;
      }
      this.$emit("sort", {
        sortDirection: this.sortDirection,
        sortKey: this.sortKey,
      });
    },
  },
};
</script>

<style></style>
